import { Button, Menu } from "@mantine/core";
import { useDisclosure } from "@mantine/hooks";
import { IconFiles } from "@tabler/icons-react";
import { useCallback } from "react";
import { useCheckPerm } from "src/hooks";
import { useSelector } from "src/redux/hooks";
import FilesModal from "src/components/shared/_Modals/FilesModal/FilesModal";

import { useMedicalDocumentsModal } from "./MedicalDocumentsModal.hooks";

interface Props {
  hamburger?: boolean;
  refetch: () => Promise<void>;
}

const MedicalDocumentsButton = ({ hamburger, refetch }: Props) => {
  const [opened, { open, close }] = useDisclosure(false);
  const checkPerm = useCheckPerm();

  // Get patient information from Redux store
  const patientInformation = useSelector(
    state => state.medicalHistory.patientInformation,
  );

  const {
    entityId: patientId,
    attachments,
    isUploading,
    handleUpload,
    handleRemove,
  } = useMedicalDocumentsModal(patientInformation, refetch);

  const Component = useCallback(
    () =>
      hamburger ? (
        <Menu.Item icon={<IconFiles size={20} />} onClick={open}>
          Documents
        </Menu.Item>
      ) : (
        <Button variant="outline" leftIcon={<IconFiles />} onClick={open}>
          Documents
        </Button>
      ),
    [hamburger, open],
  );

  if (!checkPerm("viewfiles")) {
    return <></>;
  }

  return (
    <>
      <Component />
      {opened && (
        <FilesModal
          opened={opened}
          close={close}
          _files={attachments}
          handleUpload={handleUpload}
          isUploading={isUploading}
          customHandleRemove={handleRemove}
          modalTitle="Medical Documents"
          hideRemovedToggle={true}
          readonly={false}
          patientId={patientId}
        />
      )}
    </>
  );
};

export default MedicalDocumentsButton;
